import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TPAProbeLabel } from '../models/tpa-test-data.modal';

export interface SampleInformationDialogData {
  stageNumber: number | null;
  probeLabels: TPAProbeLabel[];
}

@Component({
    selector: 'app-sample-information-dialog',
    templateUrl: './sample-information-dialog.component.html',
    styleUrls: ['./sample-information-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SampleInformationDialogComponent {
  readonly displayedColumns = [
    'sensorNumber',
    'sampleId',
    'inHouseId',
    'sampleDescription',
    'projectName',
    'projectReference',
    'tr',
  ];

  constructor(
    private dialogRef: MatDialogRef<SampleInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SampleInformationDialogData,
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  formatTr(tr: number): string {
    return Number.isFinite(tr) ? tr.toFixed(0) : '—';
  }
}
